module.exports = __webpack_public_path__ + "img/2-5.7bf34cb8.svg";